import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { MonetizationDataState } from './types';

const useMonetizationDataStore = createWithEqualityFn<MonetizationDataState>(
  set => ({
    planData: [],
    setPlanData: planData => set({ planData }),
    setCheckoutOptions: checkoutOptions => set({ checkoutOptions }),
    isClickedFromSpecialOffer: false,
    setIsClickedFromSpecialOffer: isClickedFromSpecialOffer => set({ isClickedFromSpecialOffer }),
    openMonetizationPopup: false,
    monetizationPopupTrigger: openMonetizationPopup => set({ openMonetizationPopup }),
    promoRequired: null,
    premiumPopupPackage: null,
    setMonetizationData: props => set(prev => ({ ...prev, ...props })),
    enableTiers: null,
    forceTier: null,
    tiersDataIsLoading: null,
    setTierData: props => set(prev => ({ ...prev, ...props })),
    onPaymentSuccess: null,
    setPaymentSuccessHandler: onPaymentSuccess => set({ onPaymentSuccess }),
    isCloseDisabled: false,
    setIsCloseDisabled: isCloseDisabled => set({ isCloseDisabled }),
    isTeamDisabled: null,
    setIsTeamDisabled: isTeamDisabled => set({ isTeamDisabled }),
  }),
  shallow,
);

export default useMonetizationDataStore;
